import { render, staticRenderFns } from "./votre-resto.vue?vue&type=template&id=408f84fc&scoped=true&"
import script from "./votre-resto.vue?vue&type=script&lang=js&"
export * from "./votre-resto.vue?vue&type=script&lang=js&"
import style0 from "./votre-resto.vue?vue&type=style&index=0&id=408f84fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f84fc",
  null
  
)

export default component.exports